export default{
  namespaced: true,
  state: {
    user: {
      isLogged: false,
      name: null,
      email: null,
      status: 0,
      id: null,
    },
  },
  getters: {
    isUserEmail: (state) => {
      return state.user.email;
    }
  },
  mutations: {
    loginUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = payload.jwt;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.id = payload.id;
      //local
      localStorage.aiToken = payload.jwt;
      localStorage.sxemail = payload.email;
    },
    logoutUser(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = 0;
      state.user.id = null;
      //local
      localStorage.removeItem("aiToken");
      localStorage.removeItem("sxemail");
    },
    validateUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = localStorage.aiToken;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.id = payload.id;
    },
    setStatus(state, payload) {
      localStorage.removeItem("aiToken");
      localStorage.aiToken = payload.jwt;
      state.user.token = payload.jwt
      state.user.status = payload.status;
    },
    clearUserData(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = 0;
      state.user.id = null;
    },
  },
  actions: {
    // SET_USERDATA({commit}, payload) {
    //   console.log("action payload" + JSON.stringify(payload));
    //   commit("DO_LOGIN", true);
    //   commit("SET_USER", payload);
    //   commit("SET_TOKEN", payload);
    // },
    loginUser({commit,dispatch}, payload) {
      commit("loginUser", payload);
      //dispatch("layouts/loadSharedGrids","", { root: true });
      //commit('gridtabs/clearAll', null, { root: true });
     //commit('layouts/dropAllData', null, { root: true });
    },
    logoutUser({commit}) {
      commit("logoutUser");
      //commit('layouts/dropAllData', null, { root: true });
    },
  },
  modules: {
  }
}
